import { heroChips, heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <header id="top" className="relative w-full">
      <div className="relative min-h-[640px] md:h-[720px] w-full flex items-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20editorial%20collage%20background%2C%20dark%20moody%20film%20still%20textures%20with%20layered%20translucent%20frames%2C%20deep%20crimson%20and%20warm%20amber%20light%20leaks%2C%20faint%20audio%20waveform%20lines%20and%20video%20timeline%20scrubber%20graphics%2C%20fine%20film%20grain%2C%20dramatic%20negative%20space%20in%20the%20center%2C%20magazine%20cover%20aesthetic%2C%20high%20contrast%2C%20no%20text%2C%20no%20people&width=1800&height=1000&seq=heivideo-hero-01&orientation=landscape"
            alt="黑料视频 逐帧与声音识别分析主视觉"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85"></div>

        <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16 md:py-0">
          <div className="max-w-5xl mx-auto text-center flex flex-col items-center">
            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-100 text-xs md:text-sm tracking-wide">
              <i className="ri-focus-3-line text-base leading-none"></i>
              逐帧画面 · 声音识别 · 背景信息疑点
            </span>

            <h1 className="mt-6 font-heading font-black text-background-50 text-4xl md:text-6xl lg:text-7xl leading-tight tracking-tight">
              黑料视频
            </h1>
            <p className="mt-4 font-heading text-background-100 text-lg md:text-2xl font-semibold">
              把每一段争议素材，拆到具体的时间码
            </p>
            <p className="mt-5 max-w-3xl text-background-100/85 text-sm md:text-base leading-relaxed">
              细节越挖越细：从逐帧画面、声音识别到背景信息疑点，都按维度分开列好。
              想拉片或者查某个小破绽，顺着页面顺序看线索，基本不用再绕路。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#feed"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-list-2-line text-base leading-none"></i>
                查看最新拉片
              </a>
              <a
                href="#method"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-shield-check-line text-base leading-none"></i>
                分析方法论
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
              {heroChips.map((chip) => (
                <a
                  key={chip.id}
                  href={chip.href}
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
                >
                  <i className="ri-arrow-right-s-line text-base leading-none"></i>
                  {chip.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-background-950 w-full">
        <div className="px-4 md:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 max-w-6xl mx-auto">
            {heroStats.map((stat, index) => (
              <div
                key={stat.id}
                className={`py-5 md:py-6 px-4 md:px-5 border-background-800 ${
                  index % 2 === 1 ? "border-l" : ""
                } ${index >= 2 ? "border-t lg:border-t-0" : ""} ${
                  index > 0 ? "lg:border-l" : ""
                }`}
              >
                <div className="flex items-baseline gap-1.5">
                  <span className="font-heading font-bold text-background-50 text-2xl md:text-3xl">
                    {stat.value}
                  </span>
                  {stat.unit && (
                    <span className="text-background-400 text-xs md:text-sm">{stat.unit}</span>
                  )}
                </div>
                <p className="mt-1 text-background-400 text-xs md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}